import instance from "../ApiConfig";
import { ApiEndPoints } from "../ApiEndPoints";

export const makeCheckIn = async (data: object) => {
  try {
    const result = await instance({
      url: ApiEndPoints.BOOKING_CHECK_IN,
      method: "POST",
      data,
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

export const makeCheckOut = async (data: object) => {
  try {
    const result = await instance({
      url: ApiEndPoints.BOOKING_CHECK_OUT,
      method: "POST",
      data,
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

export const fetchBookingCheckInCheckOut = async (date, all_list = 0) => {
  try {
    const result = await instance({
      url:
        ApiEndPoints.BOOKING_CHECK_IN_CHECK_OUT +
        `?date=${date}&all_list=${all_list}`,
      method: "GET",
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};

export const createGroupBooking = async (data: object) => {
  try {
    const result = await instance({
      url: ApiEndPoints.CREATE_GROUP_BOOKING,
      method: "POST",
      data,
    });
    return result.data;
  } catch (error) {
    throw error;
  }
};
